import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8310aae8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-name" }
const _hoisted_2 = { style: {"max-width":"200px"} }
const _hoisted_3 = {
  key: 1,
  class: "status-span"
}

import { t } from '@/plugins/i18n'

import Image from '@/components/common/Image.vue'
import AppLink from '@/components/common/AppLink.vue'
import { useSite } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: {
  image: {
    type: String,
    default: ''
  },
  name: {
    type: String,
    default: ''
  },
  url: {
    type: String,
    default: ''
  },
  showStatus: {
    type: Boolean,
    default: false
  },
  errorCode: {
    type: Number,
    default: 0
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{disabled:__props.showStatus},'flex-center', 'shopping-preview-'+ _unref(useSite)()]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_component_el_popover, {
      placement: "top-start",
      width: "168",
      "popper-class": "shopping-preview",
      trigger: "hover",
      "hide-after": 30
    }, {
      reference: _withCtx(() => [
        (__props.url)
          ? (_openBlock(), _createBlock(AppLink, {
              key: 0,
              to: __props.url,
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(Image, {
                  referrerPolicy: "no-referrer",
                  class: "image name",
                  src: __props.image,
                  alt: __props.name
                }, null, 8, ["src", "alt"])
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createBlock(Image, {
              key: 1,
              referrerPolicy: "no-referrer",
              class: "image name",
              src: __props.image,
              alt: __props.name
            }, null, 8, ["src", "alt"]))
      ]),
      default: _withCtx(() => [
        _createVNode(Image, {
          class: "image-preview image-preview-name",
          src: __props.image,
          alt: __props.name
        }, null, 8, ["src", "alt"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      (__props.name)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "name",
            style: _normalizeStyle({ '-webkit-line-clamp': __props.showStatus ? 1 : 2 })
          }, [
            (__props.url)
              ? (_openBlock(), _createBlock(AppLink, {
                  key: 0,
                  to: __props.url,
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(__props.name), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 1,
                  effect: "light",
                  placement: "top",
                  "popper-class": "tool-tip-no-border"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.name), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(__props.name), 1)
                  ]),
                  _: 1
                }))
          ], 4))
        : _createCommentVNode("", true),
      (__props.showStatus)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(['', _unref(t)('已失效'), _unref(t)('已下架'), _unref(t)('库存不足'), _unref(t)('商品不存在'), _unref(t)('未关联')][__props.errorCode]), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})